<template>
  <div
    class="swap-icon"
    :class="{ disabled: disabled }"
    @click="onSwapClicked"
  />
</template>

<script>
  export default {
    props: {
      disabled: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      onSwapClicked() {
        if (!this.disabled) {
          this.$emit('swap')
        }
      }
    }
  }
</script>

<style
  lang="scss"
  scoped
  rel="stylesheet/scss"
>
  @import '~assets/styles/common.scss';

  .swap-icon {
    z-index: 0;
    background: #ffffff;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    position: absolute;
    cursor: pointer;
    top: 50%;
    right: 8px;
    transform: translate(0, -50%);
    border: 1px solid $scn-gray-border;

    @include bp-mf-desktop {
      transform: translate(-50%, -50%);
    }

    &:before {
      @include icon-font();
      content: $icon-swap-v2;
      width: 100%;
      height: 32px;
      text-align: center;
      line-height: 30px;
      color: $dark-blue;
      font-size: em(24);
    }

    &.disabled {
      border: 1px solid $grey-border-light;
      cursor: default;

      &:before {
        color: $grey-border-light;
      }
    }
  }
</style>
